export const ABSENCE_REASONS_LABELS = {
  formListName: 'absenceReasons',
  name: 'name',
  color: 'color',
};
